
import React, { useState ,useEffect , useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import  { currencySymbol }  from "../../functions/Function";
import { HomeContext } from "../Home";

const QuickBuyItem = (props) => {
    const HomeContextData = useContext(HomeContext);

    return (
        <>
            <li className={`ivo-left-index-li ivo-ovrflow-hidden ${HomeContextData.getActiveProdcutID() == props.product.id ? 'active' : ''} `}onClick={()=>props.handleClickActiveProduct(props.product.id)}>
                <Link>
                    <div className="ivo-left-ul-inner-conent">
                        {props.product.name}
                    </div>
                    <div className="ivo-left-ul-inner-conent-v-2 hover-price-list">
                        
                        {props.product.price}
                    </div>
                    <span className="delete-list-item">
                        <i className="fa-regular fa-trash-can"></i>
                    </span>
                </Link>
            </li>
        </>

    );
}

export default QuickBuyItem;
